import React from "react";
import { Route, Switch } from "react-router-dom";
import SideBar from "../SideBar";
import Test from "../../TestingComponent/Test";

const Subroutes = () => {
    return (
        <SideBar>
            <Switch>
                <Route exact component={Test} path="/SideBar" />
            </Switch>
        </SideBar>
    );
};

export default Subroutes;
